module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/messina.b8915e9f62ee83ae008d2f73e1320d0f.jpg";